// src/public/assets/js/heart-animation.js

document.addEventListener('DOMContentLoaded', () => {
    // Target elements with the class 'support-link-animated'
    const animatedLinks = document.querySelectorAll('.support-link-animated');
    const container = document.body; // Append hearts to body for fixed positioning
    let heartInterval = null;
    const heartIntervalTime = 150; // ms between hearts on hover (adjust as needed)

    // Function to create a single heart particle
    function createHeart(anchorElement) {
        if (!container) return; // Exit if body container not found

        const heart = document.createElement('span');
        heart.classList.add('heart-particle'); // Use the class defined in CSS
        heart.innerHTML = '❤'; // Or '💖' or other heart emojis

        // Calculate initial position based on the link's location
        const rect = anchorElement.getBoundingClientRect();
        // Start slightly randomized horizontally near the link's center top
        const initialX = rect.left + rect.width * (0.4 + Math.random() * 0.2); 
        const initialY = rect.top; // Start near the top edge

        // Apply initial position (fixed relative to viewport)
        heart.style.left = `${initialX}px`;
        heart.style.top = `${initialY}px`;

        // Randomize horizontal drift for the animation using a CSS variable
        const randomTranslateX = (Math.random() - 0.5) * 60; // Approx -30px to +30px drift
        heart.style.setProperty('--tx', `${randomTranslateX}px`);

        container.appendChild(heart);

        // Remove the heart element after the animation finishes to prevent buildup
        heart.addEventListener('animationend', () => {
            if (heart.parentNode) {
                heart.remove();
            }
        });
    }

    // Add listeners to all target links found
    animatedLinks.forEach(link => {
        link.addEventListener('mouseover', () => {
            // Clear any previous interval to prevent stacking
            if (heartInterval) clearInterval(heartInterval);

            // Start creating hearts continuously while hovering
            heartInterval = setInterval(() => {
                createHeart(link); // Pass the specific link element
            }, heartIntervalTime);
        });

        link.addEventListener('mouseout', () => {
            // Stop creating hearts when the mouse leaves
            if (heartInterval) {
                clearInterval(heartInterval);
                heartInterval = null;
            }
        });
    });

    if (animatedLinks.length === 0) {
        console.warn("No elements found with class 'support-link-animated' for heart effect.");
    }
});